const envs = {
  local: 'local',
  development: 'development',
  production: 'production',
}

const environment = envs.production // Change this to 'development' or 'production' as needed

const configs = {
  local: require('./local.env'),
  development: require('./dev.env'),
  production: require('./prod.env'),
}

export default configs[environment]
